import { render } from "./InteractionsAction.vue?vue&type=template&id=3406424f&scoped=true"
import script from "./InteractionsAction.vue?vue&type=script&lang=js"
export * from "./InteractionsAction.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3406424f"]])

export default __exports__